import { render, staticRenderFns } from "./CandidateItemDocuments.vue?vue&type=template&id=2b9145ca&scoped=true"
import script from "./CandidateItemDocuments.vue?vue&type=script&lang=js"
export * from "./CandidateItemDocuments.vue?vue&type=script&lang=js"
import style0 from "./CandidateItemDocuments.vue?vue&type=style&index=0&id=2b9145ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9145ca",
  null
  
)

export default component.exports